/*--------------------Organization trustpilot reviews controller----------------
Contains all the functions for showing organization reviews
-------------------------------------------------------*/
import Pagination from 'components/pagination/pagination';
import scrollToElement from 'helpers/scroll/scrollTo';

export default (function () {
    const settings = {
        totalPages: 0,
        numberOfPages: 0
    };
    const summaryEl = document.querySelectorAll('#p-review-summary');

    const productReviewContainer = document.querySelector('#product-reviews-container');
    const paginationContainer = document.querySelector('#product-reviews-pagination');

    if (paginationContainer) {
        settings.totalPages = parseInt(paginationContainer.dataset.totalPages) || 0;
        settings.numberOfPages = parseInt(paginationContainer.dataset.pageLimit) || 0;
    }

    const initProductReviews = function () {
        if (summaryEl) {
            addEventListeners();
            createProductReviewPagination();
        }
    };

    const addEventListeners = function () {
        if (summaryEl !== null) {
            summaryEl.forEach((el) =>
                el.addEventListener('click', function () {
                    scrollToElement('.product-reviews');
                })
            );
        }

        if (paginationContainer !== null) {
            paginationContainer.addEventListener('click', paginationEvents);

            //Set keydown event for accesibillity
            paginationContainer.addEventListener('keydown', function (e) {
                if (e.keyCode === 13) {
                    // keycode 13 is enter/return key
                    paginationEvents(e);
                }
            });
        }
    };

    const createProductReviewPagination = function () {
        const reviewPagination = new Pagination({
            selector: '#product-reviews-pagination',
            totalPages: settings.totalPages
        });
        reviewPagination.create();
    };

    const paginationEvents = function (e) {
        const pageItem = e.target.closest('.pag-item');
        const pageControl = e.target.closest('.pag-control');

        if (pageItem) {
            const pageNumber = parseInt(pageItem.dataset.page);
            const firstReviewOfPage = pageNumber * settings.numberOfPages - settings.numberOfPages;
            const lastReviewOfPage = firstReviewOfPage + settings.numberOfPages;

            setReviewsActive(firstReviewOfPage, lastReviewOfPage);

            scrollToElement('.product-reviews');
        }

        if (pageControl) {
            const pageNumber = parseInt(paginationContainer.getAttribute('data-page')) + 1;

            if (pageNumber <= settings.totalPages && pageNumber > 0) {
                const firstReviewOfPage = pageNumber * settings.numberOfPages - settings.numberOfPages;
                const lastReviewOfPage = firstReviewOfPage + settings.numberOfPages;

                setReviewsActive(firstReviewOfPage, lastReviewOfPage);

                scrollToElement('.product-reviews');
            }
        }
    };

    const setReviewsActive = function (start, stop) {
        if (productReviewContainer) {
            const reviews = productReviewContainer.querySelectorAll('.review-item');

            reviews.forEach((review) => {
                if (review.dataset.reviewId <= start || review.dataset.reviewId > stop) {
                    review.classList.add('d-none');
                } else {
                    review.classList.remove('d-none');
                }
            });
        }
    };

    return {
        init: initProductReviews
    };
})();
